import type {StatData} from '../../types';

import {ArrowDownOutlined, ArrowUpOutlined} from '@ant-design/icons';
import {cn} from '@ds/helpers';

type StatCardProps = {
  data: StatData;
};

const StatCard: React.FC<StatCardProps> = ({data}) => {
  const isPositive = data.invertTrend ? data.trend === 'DESC' : data.trend === 'ASC';

  return (
    <article className="flex min-w-0 flex-1 flex-col gap-2 rounded-lg bg-gray-02 p-2">
      <span className="text-body-sm text-gray-08">{data.title}</span>
      <div className="flex flex-wrap items-center gap-1">
        <span className="text-subtitle-md text-neutral-fg">{data.value}</span>
        {data.subtitle && <span className="text-subtitle-md text-neutral-fg">{data.subtitle}</span>}
        {data.trend && (
          <span
            className={cn(
              'flex items-center gap-0.5 text-body-sm',
              isPositive ? 'text-success' : 'text-destructive'
            )}
          >
            {data.trend === 'ASC' ? (
              <ArrowUpOutlined aria-hidden />
            ) : (
              <ArrowDownOutlined aria-hidden />
            )}
            {data.change}
          </span>
        )}
      </div>
    </article>
  );
};

export default StatCard;
